<div class="dialog-header">
    <h3 mat-dialog-title>{{ data.title }}</h3>
    <button class="close-button" (click)="onCancel()">
        <span class="material-symbols-outlined">close</span>
    </button>
</div>
<mat-dialog-content>
    <p [innerHTML]="data.message"></p>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="button button-text" (click)="onCancel()">
        {{ data.cancelText || 'Cancel' }}
    </button>
    <button class="button" [class.btn-danger]="data.type == 'delete'" [class.btn-confirm]="data.type != 'delete'" (click)="onConfirm()">
        {{ data.confirmText || 'Confirm' }}
    </button>
</mat-dialog-actions>
